// client/src/coms/voip/voiceclient_parts/utils.js
import { DEFAULT_VOICE_ANIMATION, voiceState } from './state';

export function canSetSinkId() {
  try {
    return typeof HTMLMediaElement !== 'undefined' && typeof HTMLMediaElement.prototype.setSinkId === 'function';
  } catch {
    return false;
  }
}

export function clamp01(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return 1;
  if (n < 0) return 0;
  if (n > 1) return 1;
  return n;
}

export function extractNumericIdentityId(v) {
  const s = String(v || '').trim();
  if (!s) return 0;
  const m = s.match(/(\d+)$/);
  return m && m[1] ? Number(m[1]) : 0;
}

export function parseComsRoomName(roomName) {
  const s = String(roomName || '').trim();
  if (!s) return null;
  const m = s.match(/^coms_(\d+)_(\d+)$/);
  if (!m) return null;
  const serverId = extractNumericIdentityId(m[1]);
  const voiceChannelId = extractNumericIdentityId(m[2]);
  if (!serverId || !voiceChannelId) return null;
  return { room: s, serverId, voiceChannelId };
}

export function getActiveLocalUserId() {
  try {
    const lp = voiceState.activeRoom && voiceState.activeRoom.localParticipant ? voiceState.activeRoom.localParticipant : null;
    return extractNumericIdentityId(lp && lp.identity);
  } catch {
    return 0;
  }
}

export function normalizeVoiceAnimationValue(input) {
  const s = String(input || '').trim();
  return s || DEFAULT_VOICE_ANIMATION;
}

export function readVoiceAnimationFromLocalStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return DEFAULT_VOICE_ANIMATION;
    const raw = window.localStorage.getItem('vox:voiceAnimation');
    return normalizeVoiceAnimationValue(raw);
  } catch {
    return DEFAULT_VOICE_ANIMATION;
  }
}

export async function fetchLocalVoiceAnimationFromBackend() {
  try {
    const res = await fetch('/api/coms/me/voice-animation', {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!res.ok) {
      voiceState.localVoiceAnimation = readVoiceAnimationFromLocalStorage();
      return voiceState.localVoiceAnimation;
    }

    let data = null;
    try {
      data = await res.json();
    } catch {
      data = null;
    }

    const next =
      data && data.effective_voice_animation != null
        ? data.effective_voice_animation
        : data && data.active_voice_animation != null
          ? data.active_voice_animation
          : DEFAULT_VOICE_ANIMATION;

    voiceState.localVoiceAnimation = normalizeVoiceAnimationValue(next);

    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        if (voiceState.localVoiceAnimation === DEFAULT_VOICE_ANIMATION) {
          window.localStorage.removeItem('vox:voiceAnimation');
        } else {
          window.localStorage.setItem('vox:voiceAnimation', voiceState.localVoiceAnimation);
        }
      }
    } catch {}

    return voiceState.localVoiceAnimation;
  } catch {
    voiceState.localVoiceAnimation = readVoiceAnimationFromLocalStorage();
    return voiceState.localVoiceAnimation;
  }
}

export function getLocalVoiceAnimation() {
  return normalizeVoiceAnimationValue(voiceState.localVoiceAnimation || readVoiceAnimationFromLocalStorage());
}

export function isTauriRuntime() {
  try {
    if (typeof window === 'undefined') return false;
    if (window.__TAURI__) return true;
    if (window.__TAURI_INTERNALS__) return true;
    if (window.__TAURI_IPC__) return true;
  } catch {}
  return false;
}

export function decodeDataPayload(data) {
  try {
    if (typeof data === 'string') return data;
    if (data instanceof Uint8Array) return new TextDecoder().decode(data);
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return new TextDecoder().decode(new Uint8Array(data));
    if (ArrayBuffer.isView(data)) return new TextDecoder().decode(new Uint8Array(data.buffer, data.byteOffset, data.byteLength));
  } catch {}
  return '';
}